export default "__VITE_ASSET__BmGGBQlS__"